import type { OnboardingConfig } from "../../lib/onboarding/flowConfig.fallback";
import type {
	DonorTypeEnum,
	FertilityRoleEnum,
	FertilityStatusEnum,
	GenderEnum,
	JourneyTypeEnum,
} from "../../types/onboarding";

// Role list for a status, with surrogate gated to female (contract §3).
export function deriveRoleOptions(
	config: OnboardingConfig,
	status: FertilityStatusEnum | undefined,
	gender: GenderEnum | undefined,
): FertilityRoleEnum[] {
	if (!status) return [];
	const roles = config.flow[status]?.roles ?? [];
	return roles.filter((r) => r !== "surrogate" || gender === "female");
}

// Journey options for a status minus its exclusions (contract §3).
export function deriveJourneyOptions(
	config: OnboardingConfig,
	status: FertilityStatusEnum | undefined,
): JourneyTypeEnum[] {
	if (!status) return [];
	const rule = config.flow[status];
	if (!rule?.s7.show) return [];
	const exclude = new Set<string>(rule.s7.exclude);
	return (config.enums.journeyType as JourneyTypeEnum[]).filter(
		(j) => !exclude.has(j),
	);
}

// donorType from gender; non_binary/other must be asked (contract §3 locked).
export function deriveDonorType(
	gender: GenderEnum | undefined,
): DonorTypeEnum | undefined {
	if (gender === "female") return "egg";
	if (gender === "male") return "sperm";
	return undefined;
}
